import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import verificandoToken from '../../FuncoesGerais/VerificarToken';
import { fetchPoliticas, createPolitica, updatePolitica, deletePolitica, fetchStatusOpcoes } from '../../api/sla';
import { fetchTiposChamadoTodos, fetchCategoriasTodos } from '../../api/cadastroChamados';
import './Sla.css';

function parseJSON(v, fb) { if (v == null) return fb; if (typeof v === 'object') return v; try { return JSON.parse(v); } catch (_) { return fb; } }
const FORM_INICIAL = { id: null, nome: '', tipo_id: '', categoria_id: '', prazo_resolucao_horas: '24', limiar_risco: '80', status_pausa: [], ativo: true };

function codStatus(s) { return s.codigo_legado ?? s.codigoLegado ?? s.codigo ?? s.id; }
function nomeStatus(s) { return s.nome ?? s.descricao ?? ('Status ' + codStatus(s)); }

function PoliticasSla() {
    const history = useHistory();
    const [politicas, setPoliticas] = useState([]);
    const [tipos, setTipos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [statusOpcoes, setStatusOpcoes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [mensagem, setMensagem] = useState('');
    const [show, setShow] = useState(false);
    const [form, setForm] = useState(FORM_INICIAL);
    const [salvando, setSalvando] = useState(false);

    const verificar = useCallback(async () => {
        const ok = await verificandoApp('ATENDENTE');
        if (!ok) history.push('/');
    }, [history]);

    const carregar = useCallback(async () => {
        verificandoToken();
        setLoading(true);
        try { setPoliticas(await fetchPoliticas()); } finally { setLoading(false); }
    }, []);

    useEffect(() => {
        verificar();
        carregar();
        fetchTiposChamadoTodos().then((l) => setTipos(Array.isArray(l) ? l : []));
        fetchCategoriasTodos().then((l) => setCategorias(Array.isArray(l) ? l : []));
        fetchStatusOpcoes().then((l) => setStatusOpcoes(Array.isArray(l) ? l : []));
    }, [verificar, carregar]);

    const abrirNova = () => { setForm(FORM_INICIAL); setMensagem(''); setShow(true); };
    const abrirEdicao = (p) => {
        setForm({
            id: p.id, nome: p.nome, tipo_id: p.tipo_id || '', categoria_id: p.categoria_id || '',
            prazo_resolucao_horas: String(p.prazo_resolucao_horas || ''), limiar_risco: String(p.limiar_risco || 80),
            status_pausa: (parseJSON(p.status_pausa, []) || []).map(String), ativo: p.ativo !== 0,
        });
        setMensagem('');
        setShow(true);
    };

    const togglePausa = (cod) => {
        const c = String(cod);
        setForm((s) => ({ ...s, status_pausa: s.status_pausa.includes(c) ? s.status_pausa.filter((x) => x !== c) : [...s.status_pausa, c] }));
    };

    const salvar = async () => {
        if (!form.nome.trim()) { setMensagem('Informe o nome.'); return; }
        const prazo = parseInt(form.prazo_resolucao_horas, 10);
        if (Number.isNaN(prazo) || prazo <= 0) { setMensagem('Prazo de resolução inválido.'); return; }
        setSalvando(true);
        try {
            const body = {
                nome: form.nome.trim(), tipo_id: form.tipo_id || null, categoria_id: form.categoria_id || null,
                prazo_resolucao_horas: prazo, limiar_risco: parseInt(form.limiar_risco, 10) || 80,
                status_pausa: form.status_pausa.map(Number), ativo: form.ativo,
            };
            if (form.id) await updatePolitica(form.id, body);
            else await createPolitica(body);
            setShow(false);
            await carregar();
        } catch (e) {
            setMensagem(e?.response?.data?.error || 'Erro ao salvar política.');
        } finally { setSalvando(false); }
    };

    const remover = async (p) => {
        if (!window.confirm(`Excluir a política "${p.nome}"?`)) return;
        try { await deletePolitica(p.id); await carregar(); }
        catch (e) { setMensagem(e?.response?.data?.error || 'Erro ao excluir.'); }
    };

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="container-fluid titulo cadastro-unificado sla-page">
                    <div className="page-header d-flex flex-wrap justify-content-between align-items-center gap-2">
                        <div>
                            <h1 className="mb-0"><i className="fas fa-stopwatch me-2" />Políticas de SLA</h1>
                            <p className="text-muted small mb-0">Prazo por tipo/categoria, com status que pausam o relógio. Mais específica vence.</p>
                        </div>
                        <button type="button" className="btn btn-primary btn-sm" onClick={abrirNova}><i className="fas fa-plus me-1" />Nova política</button>
                    </div>

                    {mensagem && !show && <div className="alert alert-danger py-2 my-2">{mensagem}</div>}
                    {loading && <p className="text-muted">Carregando...</p>}
                    {!loading && politicas.length === 0 && <div className="alert alert-info py-3 mt-3">Nenhuma política. Crie ao menos uma (ex.: prazo padrão para todos os tipos).</div>}

                    {!loading && politicas.length > 0 && (
                        <div className="table-responsive mt-3">
                            <table className="table table-sm sla-table">
                                <thead><tr><th>Nome</th><th>Tipo</th><th>Categoria</th><th className="text-end">Prazo</th><th className="text-end">Risco</th><th className="text-center">Pausas</th><th className="text-center">Ativa</th><th></th></tr></thead>
                                <tbody>
                                    {politicas.map((p) => (
                                        <tr key={p.id}>
                                            <td>{p.nome}</td>
                                            <td>{p.tipo_nome || <em className="text-muted">Qualquer</em>}</td>
                                            <td>{p.categoria_nome || <em className="text-muted">Qualquer</em>}</td>
                                            <td className="text-end text-nowrap">{p.prazo_resolucao_horas}h</td>
                                            <td className="text-end">{p.limiar_risco}%</td>
                                            <td className="text-center">{(parseJSON(p.status_pausa, []) || []).length}</td>
                                            <td className="text-center">{p.ativo ? <i className="fas fa-check text-success" /> : <i className="fas fa-times text-muted" />}</td>
                                            <td className="text-end text-nowrap">
                                                <button className="btn btn-link btn-sm p-1" onClick={() => abrirEdicao(p)}><i className="fas fa-pen" /></button>
                                                <button className="btn btn-link btn-sm p-1 text-danger" onClick={() => remover(p)}><i className="fas fa-trash" /></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </main>

            {show && (
                <div className="modal-overlay" onClick={() => !salvando && setShow(false)}>
                    <div className="modal-card sla-modal" onClick={(e) => e.stopPropagation()}>
                        <h5 className="mb-3"><i className="fas fa-stopwatch me-2" />{form.id ? 'Editar política' : 'Nova política'}</h5>
                        <div className="form-group mb-2">
                            <label className="small">Nome</label>
                            <input className="form-control form-control-sm" value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} placeholder="Ex.: Padrão 24h" />
                        </div>
                        <div className="row g-2 mb-2">
                            <div className="col-6">
                                <label className="small">Tipo (vazio = qualquer)</label>
                                <select className="form-control form-control-sm" value={form.tipo_id} onChange={(e) => setForm({ ...form, tipo_id: e.target.value })}>
                                    <option value="">Qualquer</option>
                                    {tipos.map((t) => <option key={t.id} value={t.id}>{t.nome}</option>)}
                                </select>
                            </div>
                            <div className="col-6">
                                <label className="small">Categoria (vazio = qualquer)</label>
                                <select className="form-control form-control-sm" value={form.categoria_id} onChange={(e) => setForm({ ...form, categoria_id: e.target.value })}>
                                    <option value="">Qualquer</option>
                                    {categorias.map((c) => <option key={c.id} value={c.id}>{c.nome}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="row g-2 mb-2">
                            <div className="col-6">
                                <label className="small">Prazo de resolução (horas)</label>
                                <input type="number" min="1" className="form-control form-control-sm" value={form.prazo_resolucao_horas} onChange={(e) => setForm({ ...form, prazo_resolucao_horas: e.target.value })} />
                            </div>
                            <div className="col-6">
                                <label className="small">Alerta de risco (% do prazo)</label>
                                <input type="number" min="1" max="100" className="form-control form-control-sm" value={form.limiar_risco} onChange={(e) => setForm({ ...form, limiar_risco: e.target.value })} />
                            </div>
                        </div>
                        <div className="form-group mb-2">
                            <label className="small">Status que pausam o SLA</label>
                            <div className="sla-pausas">
                                {statusOpcoes.length === 0 && <span className="text-muted small">Nenhum status disponível.</span>}
                                {statusOpcoes.map((s) => {
                                    const cod = String(codStatus(s));
                                    return (
                                        <label key={cod} className={`sla-pausa-chip ${form.status_pausa.includes(cod) ? 'ativo' : ''}`}>
                                            <input type="checkbox" checked={form.status_pausa.includes(cod)} onChange={() => togglePausa(cod)} />
                                            {nomeStatus(s)}
                                        </label>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="form-check mb-2">
                            <input className="form-check-input" type="checkbox" id="sla-ativo" checked={form.ativo} onChange={(e) => setForm({ ...form, ativo: e.target.checked })} />
                            <label className="form-check-label small" htmlFor="sla-ativo">Política ativa</label>
                        </div>
                        {mensagem && <div className="alert alert-danger py-2 mb-2">{mensagem}</div>}
                        <div className="d-flex justify-content-end gap-2">
                            <button className="btn btn-secondary btn-sm" disabled={salvando} onClick={() => setShow(false)}>Cancelar</button>
                            <button className="btn btn-primary btn-sm" disabled={salvando} onClick={salvar}>{salvando ? 'Salvando...' : 'Salvar'}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default PoliticasSla;
